import { DownArrowIcon, TrashIcon } from 'assets/icons';
import cn from 'classnames';
import BetBuilderCard from 'features/eventPreMatch/component/betBuilderCard';
import { EventState, GamesState } from 'features/eventPreMatch/interface/sportPrematch';
import { AnimatePresence, motion } from 'framer-motion';
import { RefObject, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/components/form/button';
import { betbuilderEvents, setDataLayer } from 'shared/constants/datalayer';
import { OutcomesData } from 'shared/types/cms';
import './styles.scss';

interface OldBetBuilderCreatorProps {
	eventDetailData: EventState;
	totalOdds: number;
	selectedOddsArray: GamesState[];
	onClickRemoveGame: (elem: number) => void;
	clickOnCross: () => void;
	onAddBetToCoupon: () => void;
	BetBuilderCreatorRef: RefObject<HTMLDivElement>;
}

const OldBetBuilderCreator = ({
	BetBuilderCreatorRef,
	totalOdds,
	selectedOddsArray,
	eventDetailData,
	onClickRemoveGame,
	clickOnCross,
	onAddBetToCoupon,
}: OldBetBuilderCreatorProps) => {
	const { t } = useTranslation();
	const [isShowSelectedBets, setIsShowSelectedBets] = useState<boolean>(false);

	const handleClick = () => {
		setIsShowSelectedBets(!isShowSelectedBets);
	};

	const getSelectedOutcomeName = (item: GamesState) => {
		const index = item.outcomes.findIndex((outcome: OutcomesData) => outcome.outcomeId === item.outcomeId);
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		return item.outcomes[index]!.outcomeName;
	};

	useEffect(() => setDataLayer([betbuilderEvents.DATALAYER_BETBUILDER_TEST_OLD]), []);

	return (
		<AnimatePresence>
			<motion.div
				initial={{ y: '-100px' }}
				animate={{ y: 0 }}
				exit={{ y: '-100px' }}
				transition={{ ease: 'linear', duration: 0.3 }}
				ref={BetBuilderCreatorRef}
				id="BetBuilderCreate"
				className="OldBetBuilderCreator"
			>
				<div className="OldBetBuilderCreator__wrapper ">
					<div className="OldBetBuilderCreator__left">
						<div className="OldBetBuilderCreator__exchange">{t('totalCourse')}:</div>
						<div className="OldBetBuilderCreator__courseCount">{totalOdds < 0 ? Number(0).toFixed(2) : totalOdds.toFixed(2)}</div>
					</div>
					<div className="OldBetBuilderCreator__buttonWrapper">
						<Button
							btnType="secondary"
							btnHeight="small"
							onClick={() => onAddBetToCoupon()}
							disabled={totalOdds <= 0}
							className="button button--secondary add-btn"
							cyTestRef="betbuilder-add"
						>
							{t('addToCoupan')}
						</Button>

						<Button
							btnHeight="small"
							disabled={totalOdds <= 0}
							btnType="primary"
							aria-controls="fade-menu"
							aria-haspopup="true"
							className="OldBetBuilderCreator__dropdown"
							onClick={handleClick}
							cyTestRef="betbuilder-dropdown"
						>
							{selectedOddsArray.length}
							<DownArrowIcon
								className={cn('OldBetBuilderCreator__dropdown__icon', {
									'OldBetBuilderCreator__dropdown__icon--rotated': isShowSelectedBets,
								})}
							/>
						</Button>
					</div>
				</div>
				{selectedOddsArray.length > 0 && isShowSelectedBets && (
					<div className="OldBetBuilderCreator__drawer">
						<div className="OldBetBuilderCreator__drawer__top">
							<Button
								btnType="transparent"
								className="OldBetBuilderCreator__deleteAll"
								cyTestRef="betbuilder-delete"
								onClick={clickOnCross}
							>
								{t('deleteEverything')}
								<TrashIcon />
							</Button>
						</div>
						<BetBuilderCard
							eventName={eventDetailData.eventName}
							getSelectedOutcomeName={getSelectedOutcomeName}
							onClickRemoveGame={onClickRemoveGame}
							selectedOddsArray={selectedOddsArray}
							isCouponsPage={false}
							showIcon={eventDetailData.sportId}
						/>
					</div>
				)}
			</motion.div>
		</AnimatePresence>
	);
};

export default OldBetBuilderCreator;
